import { render, staticRenderFns } from "./RegistrationApplicationRejectPage.vue?vue&type=template&id=42c1f81d&scoped=true"
import script from "./RegistrationApplicationRejectPage.vue?vue&type=script&lang=ts"
export * from "./RegistrationApplicationRejectPage.vue?vue&type=script&lang=ts"
import style0 from "./RegistrationApplicationRejectPage.vue?vue&type=style&index=0&id=42c1f81d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c1f81d",
  null
  
)

export default component.exports